import React, {Component} from 'react'
import {connect} from 'react-redux'
import {getCurrentCountryAndCoordinates, getZoomForGoogleMap} from '../functions/countrySetting'

class GoogleMap extends Component {
  constructor(props){
    super(props);
  }

  render() {
    return (
      <div className="google-map-code">
        {this.props.countryOfLiving ?
          <iframe src={"https://maps.google.com/?q=" + encodeURIComponent(this.props.postalCode) + "%20" + this.props.countryOfLiving + "&key=AIzaSyARlCva6G1URRlc9g4wOMcYLnUpYmzvl4s&output=embed" } width="470" height="450" frameBorder="0" style={{border:0}} allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe>
          :
          <iframe src={"https://maps.google.com/?q=" + encodeURIComponent(this.props.postalCode) + ",%20" + getCurrentCountryAndCoordinates() + "&key=AIzaSyARlCva6G1URRlc9g4wOMcYLnUpYmzvl4s&output=embed&z=" + getZoomForGoogleMap() } width="470" height="450" frameBorder="0" style={{border:0}} allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe>
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
})
const mapDispatchToProps = dispatch => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(GoogleMap)
